/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, Input, OnInit } from '@angular/core';
import { CustomDateFormatService } from '../../../services/custom-date-format/custom-date-format.service';

@Component({
  selector: 'app-dashboard-card',
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
  standalone: false
})
export class DashboardCardComponent implements OnInit {
  @Input() cardTitle: string = '';
  @Input() cardTitleTranslation: string = '';
  @Input() cardContentTranslation: string = '';
  @Input() type: string = '';
  @Input() pipe: string = '';
  @Input() color: string = '';
  @Input() cardContent: number = 0;
  @Input() dateCardContent: string = '';
  @Input() loading: boolean = true;
  @Input() isDate: boolean = false;

  constructor(public customDateFormatService: CustomDateFormatService) {}

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
